// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2A-uX","modalForm":"UpgradeEpcsModal_modalForm__2IKyE","modalFooter":"UpgradeEpcsModal_modalFooter__1YaOK"};